export const NULL_PLACEHOLDER = 'Н/Д'
export const REQUIRED_FIELD_ERROR = "Це поле обов'язково"
export const REQUIRED_EMAIL_ERROR = 'Недійсна електронна адреса'
export const FILE_DEFAULT_NAME = 'Завантажити'
